import { render, staticRenderFns } from "./FilterTasksByDateModal.vue?vue&type=template&id=ddc0560a&scoped=true&"
import script from "./FilterTasksByDateModal.vue?vue&type=script&lang=js&"
export * from "./FilterTasksByDateModal.vue?vue&type=script&lang=js&"
import style0 from "./FilterTasksByDateModal.vue?vue&type=style&index=0&id=ddc0560a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc0560a",
  null
  
)

export default component.exports